import PropTypes from 'prop-types'

import { Container, Heading, Text } from '@redriverpress/system'
import { renderInlineMarkdown } from 'Common/utils/markdown'
import StyledHtmlContent from './StyledHtmlContent'

export default function CourseOverview({ content }) {
  return (
    <Container py={4}>
      <Heading p={0} mb={3} as='h2' fontSize={[3, null, 4]}>
        Overview
      </Heading>

      <StyledHtmlContent>
        <Text
          dangerouslySetInnerHTML={{
            __html: renderInlineMarkdown(content),
          }}
          width={[1, null, 9 / 12, 7 / 12]}
        />
      </StyledHtmlContent>
    </Container>
  )
}

CourseOverview.propTypes = {
  content: PropTypes.string.isRequired,
}
